<template>
    <div class="modal fade"  :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog" style="width: 590px;">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <div class="room_detail">
                        <div class="room_title">
                            优惠说明
                        </div>
                        <div class="room_tips">
                            <p>所有既有预订享受的优惠，可以选择转换成当前促销，但之前享受的所有促销优惠必须取消。 </p>
                            <p>上述限时闪惠可与游轮公司品牌特惠同享（另有说明的除外），不可与其他限时闪惠、船上消费抵用金、优惠券、升舱及任何其他活动等同享</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CruisePromoInfoPopup",
    props: {
        isShow: {
            type: Boolean
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal {
    .modal-dialog {
        top: 20%;
    }
}
.room_detail {
    margin-top: -1px;
    .room_title {
        font-size: 22px;
        color: #282b2c;
        margin-bottom: 10px;
        font-weight: bold;
    }
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>